import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import ImageListHolder from '../styles/ImageListModalStyle';
import { useTranslation } from 'react-i18next';
import NumberFormat from './NumberFormat';

const ImageListModal = ({ visibleSpotModal, handleDisplayModal, selectedDisplay }) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible={visibleSpotModal}
      onCancel={handleDisplayModal}
      footer={null}
      closable={true}
      title={null}
      width={800}
      bodyStyle={{ padding: 20 }}
    >
      <ImageListHolder>
        <div className="container">
          <div className="row-info">
            <div className="col-info">
              <h2>
                {t('Screen')}: {selectedDisplay.name}
              </h2>
            </div>
            <div className="col-info">
              <h4>
                {t('Investment')}:
                <span style={{ marginLeft: 8 }}>
                  <NumberFormat
                    value={selectedDisplay.totalPaid.toFixed(2)}
                    currency={selectedDisplay.currency}
                  />
                </span>
              </h4>
            </div>
            <div className="col-info">
              <h3>
                {t('Number of ads on this screen')}: {selectedDisplay.listContent.length}
              </h3>
            </div>
          </div>

          <div className="content-list">
            {/* <GenerateSkeletonComponent count={selectedDisplay.listContent.length} height={80} width="70%" /> */}
            {selectedDisplay.listContent.map(content =>
              content.type === 'video' ? (
                <video
                  key={content.id}
                  controls
                  style={{
                    maxwidth: '25%',
                    height: '25%',
                    objectFit: 'cover',
                    margin: '10px'
                  }}
                >
                  <source src={content.file} type="video/mp4" />
                </video>
              ) : (
                <img
                  key={content.id}
                  src={content.file}
                  alt={content.name}
                  style={{
                    maxwidth: '25%',
                    verticalAlign: 'sub',
                    objectFit: 'cover',
                    verticalAlign: 'none',
                    margin: '10px',
                    height: '100%'
                  }}
                />
              )
            )}
          </div>
        </div>
      </ImageListHolder>
    </Modal>
  );
};

export default ImageListModal;
